export default __webpack_public_path__ + "static/media/pdf_rapine.6b347c82.png";